import { ISection } from '../../../interfaces/scheduler_interfaces';
import { SelectedSectionActionsFacade } from '../../../views/course_scheduler/facades/selected_section_actions_facade';
import { RegisteredSectionServant } from '../../../views/course_scheduler/servants/registered_section_servant';
import { ScheduledSectionServant } from '../../../views/course_scheduler/servants/scheduled_section_servant';
import { ScheduledSectionStatusServant } from '../../../views/course_scheduler/servants/scheduled_section_status_servant';

/**
 * Servant for section selections
 * Used to determine if a checkbox should be shown for a section
 */
export class SectionSelectionsServant {
  constructor(
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngRegisteredSectionServant: RegisteredSectionServant,
    private ngSelectedSectionActionsFacade: SelectedSectionActionsFacade
  ) {}

  /**
   * Section can be selected for registration if it is scheduled or waitlisted
   * and passes these criterias: canBeRegistered, isEligibleForRegistration
   * @param section
   * @returns
   */
  canBeSelectedForRegister(section: ISection) {
    const isSectionScheduled = this.ngScheduledSectionServant.isSectionScheduled_(section);
    const canBeRegistered = this.ngScheduledSectionServant.canBeRegistered(section);
    const isSectionWaitlisted = this.ngScheduledSectionStatusServant.isStatusWaitlisted(section);

    return (isSectionScheduled || isSectionWaitlisted) && canBeRegistered && !!section._isEligibleForRegistration;
  }

  /**
   * Section can be selected for drop if it is registered or waitlisted
   * and passes these requirements: canBeDropped, isMultiDropFeatureEnabled
   * @param section
   * @returns
   */
  canBeSelectedForDrop(section: ISection) {
    const isSectionRegistered = this.ngScheduledSectionServant.isSectionRegistered(section);
    const isSectionWaitlisted = this.ngScheduledSectionStatusServant.isStatusWaitlisted(section);
    const canBeDropped =
      this.ngRegisteredSectionServant.canBeDropped(section) &&
      this.ngSelectedSectionActionsFacade.isMultiDropFeatureEnabled();
    return (isSectionRegistered || isSectionWaitlisted) && canBeDropped;
  }

  /**
   * Section can be selected for waitlist if it is scheduled
   * and passes these requirements: canBeWaitlisted, shouldShowMultiWaitlistFeature
   * @param section
   * @returns
   */
  canBeSelectedForWaitlist(section: ISection) {
    const isSectionScheduled = this.ngScheduledSectionServant.isSectionScheduled_(section);
    const canBeWaitlisted =
      this.ngScheduledSectionServant.canBeWaitlisted(section) &&
      this.ngSelectedSectionActionsFacade.shouldShowMultiWaitlistFeature();
    return isSectionScheduled && canBeWaitlisted;
  }

  /**
   * Section can be selected for withdraw if it is registered
   * and passes these requirements: canBeWithdrawn
   * @param section
   * @returns
   */
  canBeSelectedForWithdraw(section: ISection) {
    const isSectionRegistered = this.ngScheduledSectionServant.isSectionRegistered(section);
    const canBeWithdrawn = this.ngRegisteredSectionServant.canBeWithdrawn(section);
    return isSectionRegistered && canBeWithdrawn;
  }
}

angular.module('capability-ng-scheduler').service('ngSectionSelectionsServant', SectionSelectionsServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_selections/servants/section_selections_servant.ts